import type { Tenant } from '../model/Tenant'

// Encapsulates all plan-limit checks in one place.
// Application services call these before creating resources.
export class PlanLimitService {
  assertCanCreateSite(tenant: Tenant, currentSiteCount: number): void {
    if (!tenant.canCreateSite(currentSiteCount)) {
      throw new Error(
        `Plan limit reached: your "${tenant.plan}" plan allows ${this.siteLimit(tenant)} site(s). Upgrade to create more.`,
      )
    }
  }

  assertCanCreatePage(tenant: Tenant, currentPageCount: number): void {
    if (!tenant.canCreatePage(currentPageCount)) {
      throw new Error(
        `Plan limit reached: your "${tenant.plan}" plan allows ${this.pageLimit(tenant)} pages per site. Upgrade to create more.`,
      )
    }
  }

  assertCanCreateBlogPost(tenant: Tenant, currentPostCount: number): void {
    if (!tenant.canCreateBlogPost(currentPostCount)) {
      throw new Error(
        `Plan limit reached: your "${tenant.plan}" plan allows ${this.postLimit(tenant)} blog posts. Upgrade to create more.`,
      )
    }
  }

  private siteLimit(tenant: Tenant): string {
    if (tenant.plan === 'custom') return String(tenant.customLimits?.siteLimit ?? 1)
    return tenant.plan === 'free' ? '1' : tenant.plan === 'starter' ? '5' : 'unlimited'
  }

  private pageLimit(tenant: Tenant): string {
    if (tenant.plan === 'custom') return String(tenant.customLimits?.pageLimit ?? 5)
    return tenant.plan === 'free' ? '5' : 'unlimited'
  }

  private postLimit(tenant: Tenant): string {
    if (tenant.plan === 'custom') return String(tenant.customLimits?.postLimit ?? 5)
    return tenant.plan === 'free' ? '5' : 'unlimited'
  }
}
